(function () {
  var BUTTON_ID = 'cyspera-invoice-btn';
  var debounceTimer = null;
  var PROXY_PATH = window.CYSPERA_PROXY_PATH || '/apps/invoices';

  function getOrderIdFromHash() {
    var match = window.location.hash.match(/#k-hub\/orders\/(\d+)/);
    return match ? match[1] : null;
  }

  function getOrderNameFromDOM() {
    var candidates = document.querySelectorAll(
      '.kl-hub-order-summary__top .kl-hub-p-small'
    );
    for (var i = 0; i < candidates.length; i++) {
      var text = candidates[i].textContent || '';
      var match = text.match(/#(\d+)/);
      if (match) return '#' + match[1];
    }
    return null;
  }

  function removeInvoiceButton() {
    var existing = document.getElementById(BUTTON_ID);
    if (existing) existing.remove();
  }

  function injectInvoiceButton() {
    var shopifyOrderId = getOrderIdFromHash();

    if (!shopifyOrderId) {
      removeInvoiceButton();
      return;
    }

    if (document.getElementById(BUTTON_ID)) return;

    var trackBtn = document.querySelector('[data-testid="track-order-button"]');
    if (!trackBtn) return;

    var orderName = getOrderNameFromDOM();

    var btn = document.createElement('button');
    btn.id = BUTTON_ID;
    btn.type = 'button';
    btn.className = trackBtn.className;
    btn.innerHTML = '<span>Download Invoice</span>';

    btn.addEventListener('click', function () {
      window.open(
        PROXY_PATH + '/invoice?order_id=' + encodeURIComponent(shopifyOrderId),
        '_blank',
        'noopener'
      );
    });

    trackBtn.insertAdjacentElement('afterend', btn);
  }

  function onHashChange() {
    removeInvoiceButton();
    scheduleInject();
  }

  function scheduleInject() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(injectInvoiceButton, 150);
  }

  window.addEventListener('hashchange', onHashChange);

  var observer = new MutationObserver(function () {
    scheduleInject();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
